let DeviceUtil = require("../util/DeviceUtil");

let Table = mc.widgets.Table;
let IconButton = mc.widgets.IconButton;

let SubjectRecordings = function (props) {
  let { subject, term, direction, onSort, isModal } = props;

  let cols = [
    {
      prop: "recordingStartTs",
      label: tx("date_time"),
      content: function (rec) {
        let startTs = rec.recordingStartTs;
        let studyId = subject.studyId;
        let subjectId = subject.id;

        return (
          <a href={mc.router.resolve("RECORDING_DATA_VIEW", { studyId, subjectId, startTs })}>
            {mc.format.datetime(startTs, subject.timezone)}
          </a>
        );
      },
      width: "35%",
      sort: true
    },
    {
      prop: "desc",
      label: tx("description"),
      content: function (rec) {
        let mode = DeviceUtil.getMode(rec);
        let signal = (rec.physicalConfig || {}).signal;
        let device = subject.devices.find((d) => d.udid === rec.udid);
        let serial = device ? device.deviceSerial : "???";
        let tooltip = tx(mode + "." + (signal || "-") + ".abbr") + " - " + serial;

        return (
          <span data-tooltip={tooltip}>
            {rec.desc}
          </span>
        );
      },
      width: "40%"
    },
    {
      prop: "duration",
      label: tx("duration"),
      content: function (rec) {
        let duration = rec.recordingStopTs - rec.recordingStartTs;

        return mc.format.duration(duration);
      },
      width: "20%"
    },
    {
      prop: "export",
      label: "",
      content: function (rec) {
        if (!isModal && rec.export) {
          let size = mc.format.filesize(rec.export.sizeBytes);
          let label = tx("rec_csv", { size });
          let url = rec.export.href.replace(/^\/v\d+/, "");

          let download = function () {
            mc.ajax.get(url).then(function (response) {
              location.href = mc.ajax.parse(response).href;
            }).catch(function (error) {
              mc.logger.error(error.toString());
            });
          };

          return <IconButton icon="download" label={label} onPress={download}/>;
        }

        return <span/>;
      },
      width: "5%"
    }
  ];

  let results = (subject.recordings || []).map(function (rec) {
    rec.desc = tx("N/A");

    if (rec.physicalConfig) {
      rec.desc = tx(rec.physicalConfig.location);

      if (rec.physicalConfig.side !== "NONE") {
        rec.desc += " – " + tx("side." + rec.physicalConfig.side);
      }
    }

    return rec;
  });

  return (
    <Table
      data={mc.utils.filter(results, ["desc"], term)} 
      cols={cols}
      sort="recordingStartTs"
      direction={direction}
      onSort={onSort}
      align="middle"/>
  );
};

module.exports = SubjectRecordings;